import { Component, Input } from "@angular/core";
import { ModalService } from "src/services/modal/modal.service";
import { FullScreenPictureModalComponent } from "./modal/full-screen-picture-modal.component";

@Component({
  selector: "rc-clickable-thumbnail",
  templateUrl: "./clickable-thumbnail.component.html",
  styleUrls: ["./clickable-thumbnail.component.scss"],
  standalone: false,
})
export class ClickableThumbnailComponent {
  @Input() public description: string | undefined;
  @Input() public src: string;

  public constructor(private readonly modalService: ModalService) {}

  public async openImageModal(): Promise<void> {
    await this.modalService.presentModal(FullScreenPictureModalComponent, {
      description: this.description,
      src: this.src,
    });
  }
}
